export enum TimelineHoursPreset {
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
  DAY = 'day',
  NIGHT = 'night',
  COMPLETE_DAY = 'completeDay',
}
